import { GENERAL_LINKS, GESTION_LINKS, ITP_LINKS, TECH_LINKS, TRAMIT_LINKS } from './links';

export const shortcuts = [
  { id: 1, title: 'Accesos directos', links: GENERAL_LINKS },
  { id: 2, title: 'Tech', links: TECH_LINKS },
  { id: 3, title: 'Gestión', links: GESTION_LINKS },
  { id: 4, title: 'Tramitación', links: TRAMIT_LINKS },
  { id: 5, title: 'Haciendas', links: ITP_LINKS },
];
